import { defaultIconProps, IconProps } from './IconProps';

export const IconResizeNE: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g filter="url(#filter0_d_1_2769)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7691 20.948L22.4727 11.2445L25.7072 14.479L26.7853 4.77544L17.0818 5.85361L20.3163 9.08811L10.6128 18.7916L7.3783 15.5571L6.30013 25.2606L16.0036 24.1825L12.7691 20.948V20.948Z"
        fill="#363B3E"
      />
      <path
        d="M27.5432 4.8594L26.4646 14.5628L26.2899 16.1393L22.4727 12.322L13.8472 20.9475L17.6645 24.7647L16.0873 24.9401L6.3846 26.018L5.43718 26.123L5.54284 25.1763L6.62007 15.4729L6.79615 13.8964L10.6127 17.713L19.2382 9.08754L15.4216 5.27096L16.9974 5.09556L26.7015 4.01764L27.6482 3.91199L27.5432 4.8594Z"
        stroke="white"
        strokeOpacity="0.8"
        strokeWidth="1.52476"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1_2769"
        x="-6.19888e-05"
        y="9.53674e-06"
        width="33.0856"
        height="33.0856"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1.52476" />
        <feGaussianBlur stdDeviation="2.28714" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_2769" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_2769" result="shape" />
      </filter>
    </defs>
  </svg>
);

IconResizeNE.defaultProps = defaultIconProps;
